<template>
  <div id="app">


    <el-container>
      <!-- 顶部 -->
      <el-header style="height: auto;">
        <el-row>
          <el-col :span="20" :offset="2">
            <el-row>
              <el-col :xs="8" :sm="6" :md="4" :lg="4" :xl="4">
                <div class="logo">
                  <img src="./assets/logo.png" alt="">
                </div>
              </el-col>
              <el-col :xs="16" :sm="18" :md="20" :lg="20" :xl="20">
                <div class="header_nav">
                  <el-menu class="hidden-sm-and-down" mode="horizontal">
                    <template v-for="yylist in menulist">
                      <el-submenu v-if="yylist.ylist && yylist.ylist.length > 0 && yylist.expandable !== false" :index="yylist.yyid"
                                  :key="yylist.yyid">
                        <template slot="title">
                          <router-link :to="{path:yylist.yrouterul,query: yylist.yid}">{{ yylist.yname }}</router-link>
                        </template>
                        <template v-for="eelist in yylist.ylist">
                          <!-- <el-menu-item  v-if="yylist.ylist && yylist.ylist.length > 0" :key="eelist.eid" :index="eelist.eeid">
                            <router-link :to="{path:'/three',query:{id: eelist.eid}}">{{eelist.ename}}</router-link>
                          </el-menu-item> -->

                          <!--  -->
                          <template v-if="eelist.elist.length > 0">
                            <el-submenu :index="eelist.eeid">
                              <template slot="title">{{ eelist.ename }}</template>
                              <el-menu-item v-for="sslist in eelist.elist" :index="sslist.ssid" :key="sslist.sid">
                                <router-link :to="{path:'/three',query:{id: eelist.eid}}">{{ sslist.sname }}
                                </router-link>
                              </el-menu-item>
                            </el-submenu>
                          </template>
                          <template v-if="eelist.elist.length == 0">
                            <el-menu-item v-if="yylist.ylist && yylist.ylist.length > 0" :key="eelist.eid"
                                          :index="eelist.eeid">
                              <router-link :to="{path:'/three',query:{id: eelist.eid}}">{{ eelist.ename }}</router-link>
                            </el-menu-item>
                          </template>
                          <!--  -->

                        </template>
                      </el-submenu>

                      <el-menu-item v-else="yylist.ylist && yylist.ylist.length ==  0" :key="yylist.yid"
                                    :index="yylist.yyid">
                        <router-link v-if="yylist.yid != 1" :to="{path:yylist.yrouterul,query: yylist.yid}">
                          {{ yylist.yname }}
                        </router-link>
                        <router-link v-if="yylist.yid == 1" to="/">{{ yylist.yname }}</router-link>
                      </el-menu-item>
                    </template>

                  </el-menu>
                  <el-menu class="hidden-md-and-up" mode="horizontal">
                    <el-menu-item index="1">
                      <i class="el-icon-menu" @click="navshow = !navshow"></i>
                    </el-menu-item>
                  </el-menu>
                </div>
              </el-col>
            </el-row>
            <transition name="el-zoom-in-top">
              <!-- 移动端 -->
              <el-row v-show="navshow" class="mobel hidden-md-and-up transition-box">
                <el-col :xs="24" class="transition-box">
                  <el-menu default-active="2" class="el-menu-vertical-demo transition-box">


                    <template v-for="yylist in menulist">
                      <!-- 一级  有二级 -->
                      <el-submenu class="transition-box" v-if="yylist.ylist && yylist.ylist.length > 0 && yylist.expandable !== false"
                                  :index="yylist.yyid" :key="yylist.yyid">
                        <template slot="title">
                          <i class="el-icon-location"></i>
                          <router-link :to="{path:yylist.yrouterul,query: yylist.yid}">{{ yylist.yname }}</router-link>
                        </template>
                        <el-menu-item-group>
                          <template v-for="eelist in yylist.ylist">
                            <!-- 二级 有三级 -->
                            <template v-if="eelist.elist.length > 0">
                              <el-submenu :index="eelist.eeid">
                                <template slot="title">{{ eelist.ename }}</template>
                                <el-menu-item v-for="sslist in eelist.elist" :index="sslist.ssid" :key="sslist.sid">
                                  <router-link :to="{path:'/three',query:{id: eelist.eid}}">{{ sslist.sname }}
                                  </router-link>
                                </el-menu-item>
                              </el-submenu>
                            </template>
                            <!-- 二级 没有三级 -->
                            <template v-if="eelist.elist.length == 0">
                              <el-menu-item v-if="yylist.ylist && yylist.ylist.length > 0" :key="eelist.eid"
                                            :index="eelist.eeid">
                                <router-link :to="{path:'/three',query:{id: eelist.eid}}">{{ eelist.ename }}
                                </router-link>
                              </el-menu-item>
                            </template>
                          </template>
                        </el-menu-item-group>
                      </el-submenu>
                      <!-- 一级 没有二级 -->
                      <el-menu-item class="transition-box" v-else="yylist.ylist && yylist.ylist.length ==  0"
                                    :key="yylist.yid"
                                    :index="yylist.yyid">
                        <i class="el-icon-document"></i>
                        <span slot="title">
													<router-link v-if="yylist.yid != 1"
                                       :to="{path:yylist.yrouterul,query: yylist.yid}">{{ yylist.yname }}</router-link>
													<router-link v-if="yylist.yid == 1" to="/">{{ yylist.yname }}</router-link>
												</span>
                      </el-menu-item>
                    </template>


                  </el-menu>
                </el-col>
              </el-row>
            </transition>
          </el-col>
        </el-row>

      </el-header>
      <!-- 中部 -->
      <el-main>
        <router-view/>
      </el-main>
      <!-- 底部 -->
      <el-footer style="height: auto;" class="footer">
        <el-row>

          <template v-for="(value,key,index) in menulist">
            <el-col v-if="value.ylist.length != 0" :key="value.yyid" :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
              <ul>
                <h3>
                  <router-link :to="{path: value.yrouterul,query: value.yid}">{{ value.yname }}</router-link>
                </h3>
                <template v-if="value.expandable !== false">
                  <li v-for="navylistlist in value.ylist" :key="navylistlist.eeid">
                    <router-link :to="{path:'/three',query:{id: navylistlist.eid}}">{{ navylistlist.ename }}</router-link>
                  </li>
                </template>
              </ul>
            </el-col>
          </template>

          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <ul>
              <li><i class="el-icon-message"></i>邮箱：2996762481@qq.com</li>
              <li><i class="el-icon-location-outline"></i>地址：广州市天河区黄村三联路12号B2栋一楼B1097</li>
            </ul>
          </el-col>
        </el-row>
        <el-row class="footer_row2">
          <el-col :xs="24">
            Copyright © 2023 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021148144号-8</a> 广州锐动网络科技有限公司
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
    <!-- 返回顶部 -->
    <el-button size="mini" circle class="buttontop" @click="backTop" v-show="backTopShow">
      <i class="el-icon-upload2"></i>
    </el-button>

  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      backTopShow: false,
      navshow: false,
      menulist: [
        {
          yid: 1,
          yyid: '1',
          yname: '首页',
          ylist: [],
          yrouterul: '/'
        },
        {
          yid: 2,
          yyid: '2',
          yname: '关于我们',
          ylist: [],
          yrouterul: '/about'
        },

        {
          yid: 3,
          yyid: '3',
          yname: '解决方案',
          yrouterul: '/solution',
          ylist: [
            {
              eid: 32,
              eeid: '3-2',
              ename: '企业应用集成',
              elist: []
            },
            {
              eid: 33,
              eeid: '3-3',
              ename: '数据存储与备份',
              elist: []
            },
            {
              eid: 38,
              eeid: '3-8',
              ename: '网站建设解决方案',
              elist: []
            }
          ]
        },
        {
          yid: 4,
          yyid: '4',
          yname: '客户案例',
          expandable: false,
          ylist: [
            {
              eid: 41,
              eeid: '4-1',
              ename: '客户案例',
              elist: [{
                sid: 411,
                ssid: '4-1-1',
                sname: '客户案例',
                slist: []
              }]
            },
          ],
          yrouterul: '/customercase'
        },
        {
          yid: 6,
          yyid: '6',
          yname: '联系我们',
          ylist: [],
          yrouterul: '/contactus'
        }


      ]
    }
  },
  methods: {
    backTop() {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 100;
          document.documentElement.scrollTop -= 100;
        } else {
          clearInterval(back)
        }
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop + document.body.scrollTop > 100) {
        this.backTopShow = true;
      } else {
        this.backTopShow = false;
      }
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.navshow = false;
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted: function () { //挂载结束状态

    window.addEventListener('scroll', this.handleScroll);
    /* 加载完成在页面顶部 */
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
  }
}
</script>

<style>
body {
  margin: 0;
}

ul,
li,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

a:-webkit-any-link {
  color: #000000;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}

/* herder */
.el-header {
  color: #333;
  text-align: center;
  line-height: 90px;
  box-sizing: border-box;
  overflow: hidden;
}

.logo,
.logo img {
  height: 90px;
}

.logo img {
  vertical-align: middle;
}


.header_nav {
  height: 90px;
}

.el-menu {
  padding-left: 50;

}

.header_nav ul {
  height: 100%;
  float: right;
}

.header_nav ul li {
  height: 100%;
}

.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 90px;
  line-height: 90px;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0;
}

.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu {
  /* float: right; */
}

.mobel .el-menu {
  border-right: 0;
}

.mobel .el-menu > li {
  border-bottom: 1px solid #8CC5FF;
}

/* main */
.el-main {
  /* background-color: #E9EEF3; */
  color: #EDF2FC;
  text-align: center;
  /* line-height: 90px; */
  padding: 0;
}


/* footer */
.footer {
  background-color: rgb(31, 37, 38);
  color: #F0F2F5;
  padding: 30px 30px;
}

.footer_row2 {
  margin: 20px;
  padding: 20px 20px;
  border-top: 1px solid #EBEEF5;
}

/*  */
.buttontop {
  position: fixed;
  right: 50px;
  bottom: 50px;
}

.footer h3,
.footer a {
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue